import { connect } from "react-redux";

import GroupedMultiSelect from "../../shared_components/grouped_multi_select";
import { citiesChanged } from "../actions/filters";

const mapStateToProps = (state) => {
  const values = state.main.filters.cities.options;
  const selectedValues = state.main.filters.cities.selectedValues;
  const clearable = true;

  return { values, selectedValues, clearable };
};

const mapDispatchToProps = dispatch => ({
  onChange: (e) => { dispatch(citiesChanged(e)); }
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupedMultiSelect);
